/* EZT Upgrade Finder: lifecycle-safe headline animation. */
if (!customElements.get('ezt-upgrade-rotator')) {
  customElements.define('ezt-upgrade-rotator', class extends HTMLElement {
    connectedCallback() {
      this.words = [...this.querySelectorAll('.ezt-gs-word')];
      this.index = 0;
      this.paused = false;
      this.animations = [];
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.button = this.closest('.ezt-guided-search-wrapper').querySelector('[data-motion-toggle]');
      this.button?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.button.textContent = this.paused ? 'Resume animation' : 'Pause animation';
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.reset();
      }, options);
      this.motion.addEventListener('change', () => this.reset(), options);
      document.addEventListener('visibilitychange', () => this.reset(), options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.words.indexOf(event.target.closest('.ezt-gs-word'));
        if (index >= 0) { this.index = index; this.editorPaused = true; this.reset(); }
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.reset(); }, options);
      this.reset();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.animations?.forEach(animation => animation.cancel());
      this.controller?.abort();
    }
    reset() {
      clearTimeout(this.timer);
      this.animations.forEach(animation => animation.cancel());
      this.animations = [];
      const isStatic = this.motion.matches || this.dataset.enabled !== 'true' || !this.words.length;
      this.toggleAttribute('data-static', isStatic);
      this.words.forEach((word, index) => {
        word.style.opacity = index === this.index ? '1' : '0';
        word.style.visibility = index === this.index ? 'visible' : 'hidden';
      });
      if (this.button) this.button.hidden = isStatic || this.words.length < 2;
      if (!isStatic && !this.paused && !this.editorPaused && !document.hidden && this.words.length > 1) this.schedule();
    }
    schedule() {
      this.timer = setTimeout(() => this.advance(), Math.max(2, Number(this.dataset.hold) || 3) * 1000);
    }
    advance() {
      if (!this.isConnected) return;
      const previous = this.words[this.index];
      this.index = (this.index + 1) % this.words.length;
      const next = this.words[this.index];
      const transforms = {
        slide: ['translateY(-35%)', 'translateY(35%)'],
        fade: ['none', 'none'],
        zoom: ['scale(.95)', 'scale(1.05)'],
        flip: ['perspective(600px) rotateX(65deg)', 'perspective(600px) rotateX(-65deg)']
      };
      const [exit, enter] = transforms[this.dataset.style] || transforms.slide;
      const timing = { duration: Number(this.dataset.duration) || 500, easing: 'cubic-bezier(.22,.61,.36,1)' };
      next.style.visibility = 'visible';
      next.style.opacity = '1';
      previous.style.opacity = '0';
      this.animations = [
        previous.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: exit }], timing),
        next.animate([{ opacity: 0, transform: enter }, { opacity: 1, transform: 'none' }], timing)
      ];
      Promise.all(this.animations.map(animation => animation.finished)).then(() => {
        previous.style.visibility = 'hidden';
        this.animations = [];
        if (this.isConnected && !this.paused && !this.editorPaused && !document.hidden && !this.motion.matches) this.schedule();
      }).catch(() => {});
    }
  });
}
